import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { isNullOrWhiteSpace } from 'ecs-react-components/dist/index.es';

export class SecondaryDisplayItem extends React.Component {
  render() {
    let shouldDisplayContent = false;
    if (this.props.isNumeric === true) {
      shouldDisplayContent = this.props.value !== null && this.props.value > 0;
    } else if (this.props.isDate === true) {
      shouldDisplayContent = this.props.value !== null && new Date(this.props.value) > new Date('1900-01-01');
    } else if (this.props.value !== null) {
      shouldDisplayContent = !isNullOrWhiteSpace(this.props.value.toString());
    } else {
      shouldDisplayContent = false;
    }

    if (this.props.isActive === false) {
      shouldDisplayContent = false;
    }

    const value = this.props.isDate ?
      moment(this.props.value).locale(this.props.language).format('L') :
      this.props.value;

    return (
      shouldDisplayContent ?
          <span className="list-item right-border">
            {this.props.label}
            {value}
          </span>
        : null
    );
  }
}
SecondaryDisplayItem.propTypes = {
  label: PropTypes.object.isRequired,
  value: PropTypes.any,
  isNumeric: PropTypes.bool,
  isDate: PropTypes.bool,
  language: PropTypes.string,
  isActive: PropTypes.bool,
};
